import React from 'react'
import technewsimg from "../assets/images/newsectionimg1.png"
import technewsimg2 from "../assets/images/newsectionimg2.png"
import technewsimg3 from "../assets/images/newsectionimg3.png"
import technewsimg4 from "../assets/images/newsectionimg4.png"
import technewsimg5 from "../assets/images/newsectionimg5.png"
import technewsimg6 from "../assets/images/newsectionimg6.png"
import technewsimg7 from "../assets/images/newsectionimg7.png"
import technewsimg8 from "../assets/images/newsectionimg8.png"
import technewsimg9 from "../assets/images/newsectionimg9.png"
import Homefooter from '../components/homefooter/Homefooter'
import LinkNavbar from '../components/linksnavbar/LinkNavbar'
import CreateCompanyFooter from '../components/createcompanyfooter/CreateCompanyFooter'
import { Link } from 'react-router-dom'

const TrendingNews = () => {
    return (
        <div>
            {/* <LinkNavbar/> */}
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <h4 className='latest_tech_news_h4 text-center pb-3 pt-lg-4 mt-2'>Latest Tech News</h4>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                        <Link style={{ textDecoration: "none" }} to="https://medium.com/@deshpandesamarth10/amazon-just-laid-off-14-000-managers-are-you-next-66a03da66b0c" target='_blank'>
                            <div className="newsection_box px-lg-0 px-md-2 px-2">
                                <div className='text-center py-2'>
                                    <img src={technewsimg} className='img-fluid px-lg-0 px-md-2 px-2'></img>
                                </div>
                            </div>
                            <div className='px-3 pt-2'>
                                <h3 className='newssection_h3 text-center'>Amazon to Layoff <br /> Managers</h3>
                            </div>
                        </Link>
                    </div>
                    <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                        <Link style={{ textDecoration: "none" }} to="https://medium.com/@ironhack/cloud-computing-innovations-whats-next-in-2025-7c4b656366f4" target='_blank'>
                            <div className="newsection_box">
                                <div className='text-center py-2'>
                                    <img src={technewsimg2} className='img-fluid px-lg-0 px-md-2 px-2'></img>
                                </div>
                            </div>
                            <div className='px-3 pt-2'>
                                <h3 className='newssection_h3 text-center'>Cloud in 2025
                                    <br /> Future or Past?</h3>
                            </div>
                        </Link>
                    </div>
                    <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                        <Link style={{ textDecoration: "none" }} to="https://hatchworks.com/blog/gen-ai/generative-ai" target='_blank'>
                            <div className="newsection_box">
                                <div className='text-center py-2'>
                                    <img src={technewsimg3} className='img-fluid px-lg-0 px-md-2 px-2'></img>
                                </div>
                            </div>
                            <div className='px-3 pt-2'>
                                <h3 className='newssection_h3 text-center'>2025 Guide to <br /> Generative AI</h3>
                            </div>
                        </Link>
                    </div>
                </div>
                <div className='row pt-2'>
                    <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                        <Link style={{ textDecoration: "none" }} to="https://medium.com/@ironhack/how-to-become-a-data-analyst-in-2025-904c8445a2f8" target='_blank'>
                            <div className="newsection_box">
                                <div className='text-center py-2'>
                                    <img src={technewsimg4} className='img-fluid px-lg-2 px-md-2 px-2' style={{ borderRadius: "1em" }}></img>
                                </div>
                            </div>
                            <div className='px-3 pt-2'>
                                <h3 className='newssection_h3 text-center'>How to Become a Data Analyst in 2025
                                </h3>
                            </div>
                        </Link>
                    </div>
                    <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                        <Link style={{ textDecoration: "none" }} to="https://medium.com/@ironhack/10-tech-podcasts-you-dont-want-to-miss-in-2025-af8405caae2e" target='_blank'>
                            <div className="newsection_box">
                                <div className='text-center py-2'>
                                    <img src={technewsimg5} className='img-fluid px-lg-2 px-md-2 px-2' style={{ borderRadius: "1em" }}></img>
                                </div>
                            </div>
                            <div className='px-3 pt-2'>
                                <h3 className='newssection_h3 text-center'>10 Tech Podcasts You Don’t Want to Miss in 2025</h3>
                            </div>
                        </Link>
                    </div>
                    <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                        <Link style={{ textDecoration: "none" }} to="https://medium.com/@ironhack/what-is-a-tech-lead-ee66622953e6" target='_blank'>
                            <div className="newsection_box">
                                <div className='text-center py-2'>
                                    <img src={technewsimg6} className='img-fluid px-lg-2 px-md-2 px-2' style={{ borderRadius: "1em" }}></img>
                                </div>
                            </div>
                            <div className='px-3 pt-2'>
                                <h3 className='newssection_h3 text-center'>What is a Tech Lead?</h3>
                            </div>
                        </Link>
                    </div>
                </div>
                <div className='row pt-2'>
                    <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                        <Link style={{ textDecoration: "none" }} to="https://medium.com/@ironhack/2025-tech-job-market-in-demand-roles-and-skills-d901eab1aad9" target='_blank'>
                            <div className="newsection_box">
                                <div className='text-center py-2'>
                                    <img src={technewsimg7} className='img-fluid px-lg-2 px-md-2 px-2' style={{ borderRadius: "1em" }}></img>
                                </div>
                            </div>
                            <div className='px-3 pt-2'>
                                <h3 className='newssection_h3 text-center'>2025 Tech Job Market: In-Demand Roles and Skills</h3>
                            </div>
                        </Link>
                    </div>
                    <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                        <Link style={{ textDecoration: "none" }} to="https://medium.com/@ironhack/become-a-ux-ui-designer-in-2025-e7c62c1e6607" target='_blank'>
                            <div className="newsection_box">
                                <div className='text-center py-2'>
                                    <img src={technewsimg8} className='img-fluid px-lg-2 px-md-2 px-2' style={{ borderRadius: "1em" }}></img>
                                </div>
                            </div>
                            <div className='px-3 pt-2'>
                                <h3 className='newssection_h3 text-center'>Become a UX/UI Designer in 2025</h3>
                            </div>
                        </Link>
                    </div>
                    <div className="col-lg col-md-4 col-sm-6 col-12 mb-3">
                        <Link style={{ textDecoration: "none" }} to="https://medium.com/@ironhack/5-habits-to-make-your-2025-better-than-2024-2f81a90d338f" target='_blank'>
                            <div className="newsection_box">
                                <div className='text-center py-2'>
                                    <img src={technewsimg9} className='img-fluid px-lg-0 px-md-2 px-2'></img>
                                </div>
                            </div>
                            <div className='px-3 pt-2'>
                                <h3 className='newssection_h3 text-center'>5 Habits to Make Your 2025 Better Than 2024</h3>
                            </div>
                        </Link>
                    </div>

                </div>
                <div className='row mb-5 mt-5'>
                    <div className='d-flex justify-content-center'>
                        <button
                            className="subscribe_btn "
                        >
                            Read More
                        </button>
                    </div>
                </div>
            </div>
            <CreateCompanyFooter />
        </div>
    )
}

export default TrendingNews
